import Super from '@simplepractice/ember-messaging-client/adapters/messaging-contact';

export default Super.extend({});
